import React from 'react'

export default function () {
    return (
        <div>
            <h1>About Contact Manager</h1>
            <p>Simple app for manage contact</p>
            <p>App version: 1.0.0</p>
        </div>
    )
}
